module.exports = __webpack_public_path__ + "static/img/zhuanli.8efdeb1d.png";